module.exports = __webpack_public_path__ + "static/img/icon-syS.57526ab3.png";